<template>
  <footer id="global-footer">
    <div class="container">
      <div class="row -with-padding">
        <div class="col">
          <div class="partner-list">
            <a
              href="https://www.c-asean.org/"
              target="_blank"
              class="item -left"
            >
              <img
                src="~assets/images/footer/partners/casean_logo.png"
                class="c-asean"
              >
            </a>
            <a
              href="http://www.samyan-mitrtown.com"
              target="_blank"
              class="item -right"
            >
              <img src="~assets/images/footer/partners/samyan-mitrtown-logo.svg">
            </a>
            <a
              href="https://www.tripleyhotel.com/"
              target="_blank"
              class="item -left"
            >
              <img src="~assets/images/footer/partners/triple-y-hotel-logo.svg">
            </a>
            <a
              href="http://office.samyan-mitrtown.com/"
              target="_blank"
              class="item -right"
            >
              <img src="~assets/images/footer/partners/mitrtown-office-logo.svg">
            </a>
          </div>
        </div>
      </div>
      <div class="row -with-padding">
        <div class="col">
          <div class="how-to-get-there row">
            <div class="g1" />
            <div class="slot image col-12 col-lg">
              <img
                src="~assets/images/footer/footer-img-01.png"
                class="d-none d-lg-block"
              >
              <img
                src="~assets/images/footer/footer-img-02.png"
                class="d-block d-lg-none"
              >
            </div>
            <div class="slot info col-12 col-lg-4">
              <h2 class="title">
                HOW TO GET THERE
              </h2>
              <p class="address">
                C asean Samyan CO-OP, 2nd Floor Samyan Mitrtown,
                944/1 Rama 4 Road, Wangmai, Pathumwan, Bangkok 10330
              </p>
            </div>
            <div class="slot buttons col-12 col-lg">
              <div class="row">
                <button
                  type="button"
                  class="button -orange-color col"
                  @click.prevent="openMap"
                >
                  MAP
                </button>
                <button
                  type="button"
                  class="button col"
                  @click.prevent="openGoogleMap"
                >
                  GOOGLE MAP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8 col-xl-6 order-0 order-lg-1">
          <div class="contact">
            <span class="item-holder">
              <a
                href="tel:+6622196999"
                class="item phone"
              >
                <img src="~assets/images/footer/phone.svg">
                02-219-6999
              </a>
            </span>
            <!-- <span class="item-holder">
              <a href="#" class="item social facebook">
                <img src="~assets/images/footer/social/facebook.svg">
              </a>
              <a href="#" class="item social twitter">
                <img src="~assets/images/footer/social/twitter.svg">
              </a>
              <a href="#" class="item social instagram">
                <img src="~assets/images/footer/social/ig.svg">
              </a>
              <a href="#" class="item social youtube">
                <img src="~assets/images/footer/social/youtube.svg">
              </a>
              <a href="#" class="item social line">
                <img src="~assets/images/footer/social/line.svg">
              </a>
            </span> -->
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-6 order-1 order-lg-0">
          <div class="copy">
            <span class="copy-text">&copy; C ASEAN SAMYAN CO-OP All rights reserved</span>
            <br>
            <!--<span class="sep-line -first">|</span>-->
            <a
              href="/terms"
            class="link"
          >Terms &amp; Conditions</a>
          <span class="sep-line">|</span>
          <a
            href="/privacy"
            class="link"
          >Privacy Policy</a>
        </div>
      </div>
    </div>
  </div>
  <map-modal ref="map-modal" />
</footer></template>

<script>
import MapModal from '~/components/modals/MapModal.vue'
export default {
  name: 'GlobalFooterComponent',
  components: {
    MapModal
  },
  methods: {
    openMap () {
      this.$refs['map-modal'].openModal()
    },
    openGoogleMap () {
      window.open('https://www.google.com/maps/dir//%E0%B8%8B%E0%B8%B5+%E0%B8%AD%E0%B8%B2%E0%B9%80%E0%B8%8B%E0%B8%B5%E0%B8%A2%E0%B8%99+%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%A2%E0%B9%88%E0%B8%B2%E0%B8%99+%E0%B9%82%E0%B8%84-%E0%B8%AD%E0%B8%AD%E0%B8%9B+1583+%E0%B8%96%E0%B8%99%E0%B8%99%E0%B8%9E%E0%B8%A3%E0%B8%B0%E0%B8%A3%E0%B8%B2%E0%B8%A1%E0%B8%97%E0%B8%B5%E0%B9%88+%E0%B9%94+%E0%B9%81%E0%B8%82%E0%B8%A7%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%87%E0%B9%83%E0%B8%AB%E0%B8%A1%E0%B9%88+%E0%B9%80%E0%B8%82%E0%B8%95%E0%B8%9B%E0%B8%97%E0%B8%B8%E0%B8%A1%E0%B8%A7%E0%B8%B1%E0%B8%99+%E0%B8%81%E0%B8%A3%E0%B8%B8%E0%B8%87%E0%B9%80%E0%B8%97%E0%B8%9E%E0%B8%A1%E0%B8%AB%E0%B8%B2%E0%B8%99%E0%B8%84%E0%B8%A3+10330/@13.7337659,100.4581452,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x30e299baa7596e09:0x87b1b4d86f30f73f!2m2!1d100.5281857!2d13.7337758?entry=ttu', '_blank')
    }
  }
}
</script>
